<template>
  <w-icon-wrapper
    :width='23.978'
    :height='24'
    icon-name='work-nav-ordering-icon'
    view-box='0 0 23.978 24'
  >
    <path
      id="_16_Bestellwesen_Icon"
      data-name="16_Bestellwesen_Icon"
      d="M47.2-856a2.311,2.311,0,0,1-1.695-.7,2.311,2.311,0,0,1-.7-1.7,2.311,2.311,0,0,1,.7-1.7A2.311,2.311,0,0,1,47.2-860.8a2.311,2.311,0,0,1,1.695.705,2.311,2.311,0,0,1,.705,1.7,2.311,2.311,0,0,1-.705,1.7A2.311,2.311,0,0,1,47.2-856Zm12,0a2.311,2.311,0,0,1-1.695-.7,2.311,2.311,0,0,1-.7-1.7,2.311,2.311,0,0,1,.7-1.7A2.311,2.311,0,0,1,59.2-860.8a2.311,2.311,0,0,1,1.695.705,2.311,2.311,0,0,1,.705,1.7,2.311,2.311,0,0,1-.705,1.7A2.311,2.311,0,0,1,59.2-856ZM46.18-875.2l2.88,6h8.4l3.3-6Zm-1.14-2.4h17.7a1.149,1.149,0,0,1,1.05.615,1.21,1.21,0,0,1,.03,1.245l-4.26,7.68a2.4,2.4,0,0,1-.885.93,2.334,2.334,0,0,1-1.215.33H48.52l-1.32,2.4H61.6v2.4H47.2a2.221,2.221,0,0,1-2.04-1.185,2.268,2.268,0,0,1-.06-2.355l1.62-2.94L42.4-877.6H40V-880h3.9Zm4.02,8.4h0Z"
      transform="translate(-40 880)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavOrdering' };
</script>